import { setUpAPI } from "../../Utils/api.utils"

const apiKey = process.env.REACT_APP_API_KEY;

export const getListingCatalogue = async () => {
    const parameters = {
        cmd: 'getListingCatalogue',
        apiKey: apiKey
    }
    const response = await setUpAPI('Catalogue', null, 'GET', parameters, null).catch(error => {return error});

    return response.json();
}